import { Box } from '@factorialco/deprecated-design-system'

import { ContentViewProps } from 'modules/trainings/components/content/types'
import { VideoBlock } from 'modules/trainings/lib/content/VideoBlock'

export const VideoBlockView = ({ contentItem }: ContentViewProps<VideoBlock>) => {
  return (
    <Box style={{ maxWidth: '720px', width: '100%', gap: '1rem' }}>
      <h2 className="text-3xl font-semibold f1-foreground">{contentItem.title}</h2>
      {contentItem.video.url && (
        <Box style={{ borderRadius: '1rem', overflow: 'hidden' }}>
          <video src={contentItem.video.url} controls style={{ width: '100%' }} />
        </Box>
      )}
    </Box>
  )
}
